module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal_data_table"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content panel-primary"
  }, [_c('div', {
    staticClass: "modal-header panel-heading"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "lang": "ca",
      "id": "modal_data_table_title"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal_data_table_body"
    }
  }, [_c('table', {
    attrs: {
      "id": "layer-data-table"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "lang": "ca",
      "id": "tancarDataTable"
    }
  }, [_vm._v("Tancar")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-347f0857"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/map-viewer/components/datatable-modal/datatable-modal.vue
// module id = 125
// module chunks = 0